import { Component, Input } from '@angular/core';
import { S1ButtonType, S1DownloadService } from '@app/s1';
import { IAssistenza, TipoAssistenza } from '@app/shared/models/assistenza';
import { AssistenzaService } from '@app/shared/services/assistenza.service';

@Component({
  selector: 'ser-bottoni-stampa-assistenza',
  templateUrl: './bottoni-stampa-assistenza.component.html',
  styleUrl: './bottoni-stampa-assistenza.component.scss'
})
export class BottoniStampaAssistenzaComponent {

  @Input() set assistenza(newValue: IAssistenza) {
    this._assistenza = newValue;
  };

  s1ButtonType = S1ButtonType;
  tipoAssistenza = TipoAssistenza;

  _assistenza: IAssistenza;

  constructor(private assistenzaService: AssistenzaService, private s1DownloadService: S1DownloadService) {

  }

  printScontrino() {

    this.assistenzaService.scontrino(this._assistenza?.id).subscribe(scontrino => {

      if (scontrino) {
        this.s1DownloadService.showPDF(scontrino);
      }

    })

  }

  printAssistenza() {

    this.assistenzaService.report(this._assistenza?.id).subscribe(report => {

      if (report) {
        this.s1DownloadService.showPDF(report);
      }
      
    })

  }

}
